import { Box } from '@mui/material';
import { useMemo } from 'react';
import { AddFileToProjectButton } from 'app/_model/project/components/AddFileButton';
import PageSection from 'shared/_components/page-section';
import FileGroupTools from 'shared/_model/project-files/FileGroupTools';
import ProjectFilesGroup, {
	getAddLabel,
	TITLE_MAP,
} from 'shared/_model/project-files/project-files-group';
import SelectedFilesToolbar from 'shared/_model/project-files/SelectedFilesToolbar';
import { useProjectContext } from 'shared/_pages/project/provider';
import { DocTypeFiles, TDocFile } from 'shared/constants/docs';
import { DOCUMENT_TYPES_FINISH_FILES, DOCUMENT_TYPES_MEDIA_FILES } from 'shared/constants/pouchDB';

export default function ProjectFiles() {
	const { files, addFilesNew } = useProjectContext();

	const { mediaFiles, finishFiles } = useMemo(() => {
		return {
			mediaFiles: DOCUMENT_TYPES_MEDIA_FILES.map((type) => ({
				type,
				files: files.filter((f) => f.type === type),
			})) as { type: DocTypeFiles; files: TDocFile[] }[], // TODO: Remove `as ...`
			finishFiles: DOCUMENT_TYPES_FINISH_FILES.map((type) => ({
				type,
				files: files.filter((f) => f.type === type),
			})) as { type: DocTypeFiles; files: TDocFile[] }[], // TODO: Remove `as ...`
		};
	}, [files]);

	return (
		<Box sx={(theme) => ({ overflowY: 'auto', paddingBottom: theme.spacing(4 * (2 + 2.5)) })}>
			<SelectedFilesToolbar />
			<PageSection title="Media">
				{mediaFiles.map(({ files: filesInGroup, type }) => (
					<ProjectFilesGroup key={type} files={filesInGroup} type={type} />
				))}
			</PageSection>
			{finishFiles.map(({ files: filesInGroup, type }) => (
				<PageSection
					key={type}
					title={TITLE_MAP[type]}
					actions={
						<>
							{!!addFilesNew && (
								<AddFileToProjectButton type={type} variation="section" label={getAddLabel(type)} />
							)}
							<FileGroupTools type={type} />
						</>
					}
				>
					<ProjectFilesGroup files={filesInGroup} type={type} />
				</PageSection>
			))}
		</Box>
	);
}
